import { createAsyncThunk } from '@/redux/createAsyncThunk';
import {
    AbsenteeBidDetails,
    SubmitAbsenteeBidParams,
    SubmitAbsenteeBidPayload,
} from '@/redux/modules/absenteeBid/absenteeBid.types';
import { markBidderHasPlacedBid } from '@/redux/modules/account/user/user.actions';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { AnalyticsTypes, getPlacedBidAnalytics } from '@/redux/modules/analytics';
import { fetchAllBidderBiddingInfoIfNeeded } from '@/redux/modules/bidder/biddingInfoAll/bidderBiddingInfoAll.actions';
import { fetchBidLimitBalanceIfNeeded } from '@/redux/modules/bidLimit/bidLimit.actions';
import { isUiMobile } from '@/redux/modules/browser';
import { getDeployment } from '@/redux/modules/config';
import { emptyLocation } from '@/utils/test/locationMock';

import { postPlaceAbsenteeBid, postPlaceAbsenteeBidAbsenteeBidsDefectionService } from './absenteeBid.api';

export const submitAbsenteeBid = createAsyncThunk<SubmitAbsenteeBidPayload, SubmitAbsenteeBidParams>(
    'la/ui/absenteeBid/submitAbsenteeBid',
    async (
        { absenteeBidDetails, hasAbsenteeBidDefectionService, hasGoogleAdsNewCustomer, location },
        { dispatch, getState }
    ) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const isMobile = isUiMobile(state);
        const details: AbsenteeBidDetails = {
            ...absenteeBidDetails,
            client: 'React',
            deviceType: isMobile ? 'Mobile' : 'Desktop',
        };

        const placeBid = hasAbsenteeBidDefectionService
            ? postPlaceAbsenteeBidAbsenteeBidsDefectionService
            : postPlaceAbsenteeBid;
        const response = await placeBid({
            authToken,
            deployment,
            details,
        });

        const fetchBidLimitBalance = await dispatch(
            fetchBidLimitBalanceIfNeeded({
                catalogId: details.catalogId,
                force: true,
                itemId: details.itemId,
            })
        );
        const fetchAllBidderBidding = await dispatch(fetchAllBidderBiddingInfoIfNeeded(true));
        await Promise.allSettled([fetchBidLimitBalance, fetchAllBidderBidding]);

        getPlacedBidAnalytics(
            getState(),
            details.itemId,
            details.bidAmount,
            AnalyticsTypes.Track.PlaceAbsenteeBid,
            location ?? emptyLocation,
            Boolean(hasGoogleAdsNewCustomer)
        );
        dispatch(markBidderHasPlacedBid());

        return {
            meta: {
                actionTime: Date.now(),
                itemId: details.itemId,
            },
            payload: response,
        };
    }
);
